// Integumentary subsection questionnaire constants
export enum IntegumentaryQuestionnaireItem {
  MEDICAL_BACKGROUND_INTEGUMENTARY = 'medical-background/integumentary',
  MEDICAL_BACKGROUND_INTEGUMENTARY_SKIN_COLOR = 'medical-background/integumentary/skin-color',
  MEDICAL_BACKGROUND_INTEGUMENTARY_SKIN_ISSUES = 'medical-background/integumentary/skin-issues',
  MEDICAL_BACKGROUND_INTEGUMENTARY_NAILS = 'medical-background/integumentary/nails',
  MEDICAL_BACKGROUND_INTEGUMENTARY_IDENTIFIED_WOUNDS = 'medical-background/integumentary/identified-wounds',
  MEDICAL_BACKGROUND_INTEGUMENTARY_WOUND_NOTES = 'medical-background/integumentary/wound-notes',
  MEDICAL_BACKGROUND_INTEGUMENTARY_SYSTEM_SUMMARY = 'medical-background/integumentary/system-summary'
}
